import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from '../';

const baseClasses =
  'first:border-0 border-t border-secondary-light cursor-pointer select-none outline-none';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  trackedSeries,
  isActive,
  onClick,
}) => {
  const formattedDate = `${String(new Date(date).getDate()).padStart(2, '0')}/${String(new Date(date).getMonth() + 1).padStart(2, '0')}/${String(new Date(date).getFullYear())}`;
  return (
    <div
      className={classnames(
        isActive ? 'bg-secondary-dark' : 'bg-black hover:bg-secondary-main',
        baseClasses
      )}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex="0"
    >
      <div className="flex flex-col flex-1 px-4 pb-2">
        <div className="flex flex-row items-center justify-between pt-2 pb-2">
          <div className="text-base text-white">{formattedDate}</div>
          <div className="flex flex-row items-center text-base text-blue-300">
            {/* <Icon name="group-layers" className="w-4 mx-2 text-blue-300" /> */}
            {/* {'Séries: ' + numInstances} */}
          </div>
        </div>
        <div className="flex flex-col py-1">
          <div className="flex flex-row items-center text-base text-white break-words">
            <Icon name="row-edit" className="w-4 mr-2 text-white" />
            {modalities} - {description}
          </div>
          <div className="flex flex-row items-center text-base text-white break-words">
            <Icon name="info-link" className="w-4 mr-2 text-white" />
            {numInstances}
          </div>
        </div>
      </div>
      {!!trackedSeries && (
        <div className="flex flex-2">
          <div
            className={classnames(
              'flex flex-row bg-secondary-main text-base text-white py-1 pl-2 pr-4 mt-2 ',
              isActive
                ? 'flex-1 border-t border-secondary-light justify-center'
                : 'rounded-sm mx-4 mb-4'
            )}
          >
            <Icon name="tracked" className="w-4 mr-2 text-primary-light" />
            {trackedSeries} Série(s) Rastreada(s)
          </div>
        </div>
      )}
    </div>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  trackedSeries: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default StudyItem;
